angular.module('payment').directive('onswPaymentTransactionInProgress', ['sock', function (sock) {
  return {
    scope: {
      transactionId: '@',
      overlay: '<?'
    },
    template: `
<div class="loading box">
    <div onsw-loader></div>
    <h1>{{'payment.pleaseWait' | translate}}</h1>
    <p>{{'payment.pleaseWaitText' | translate}}</p>
    <p>{{'payment.pleaseWaitTxCancellationNotice' | translate}}</p>
</div>`,
    link: function (scope, element) {
      sock.$on(scope, 'transaction.' + scope.transactionId, function () {
        element.addClass('done');
        scope.overlay && scope.overlay.close();
      });
    }
  };
}]);
